import { Map, fromJS } from 'immutable'
import { createReducer } from 'reducers/utils'
import {
  RULES_UTILS_FETCH_REQUEST,
  RULES_UTILS_FETCH_SUCCESS,
  RULES_UTILS_FETCH_FAILURE,
} from 'actions/rulesUtils'

const initialState = Map({
  data: null,
  isLoading: false,
  error: false,
})

const handlers = {
  [RULES_UTILS_FETCH_REQUEST]: (state) =>
    state.set('isLoading', true).set('error', false),

  [RULES_UTILS_FETCH_SUCCESS]: (state, { data }) =>
    state.set('isLoading', false).set('error', false).set('data', fromJS(data)),

  [RULES_UTILS_FETCH_FAILURE]: (state) =>
    // Clear stale data so a failed fetch for a new serial number never shows
    // the previous serial number's data alongside the error state.
    state.set('isLoading', false).set('error', true).set('data', null),
}

export default createReducer(initialState, handlers)
